<div *ngIf="edit_tarea.tipo == 1">
<div class="card">

    <div class="header" style="height: 40px;">
      <h5 class="title color" id="exampleabel" style="color:#a5a8ad; float:left;">Editar Tarea</h5>
      <button type="button" class="btn btn-danger btn-round"  style="float: right;" (click)="cerrar()">Cerrar Edición</button>
    </div>
    <form method="POST" #addForm="ngForm" (ngSubmit)="onSubmit(addForm)">
      <div class="body">
      <div class="form-group" style="float:right; margin:-10px;">
        <label><i class="fa fa-asterisk" style="color:#D64968; margin:5px; font-size:10px;"></i> Campos Obligatorios </label>
      </div>
      <div class="form-group">
          <label class="form-label">Nombre de la Tarea</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
          <input class="form-control" id="actividad" required [(ngModel)]="task.titulo" name="titulo">
      </div>
      <div class="form-group">
        <label class="form-label">Tipo de Fecha</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
        <div class="selectgroup2 w-100">
          <label class="selectgroup-item">
            <input type="radio" name="fecha_form" [value]="0" id="fecha_form" class="selectgroup-input"  (click)="fecha_uno()" [ngModel]="edit_tarea[0].tipo_fecha" [checked]="edit_tarea[0].tipo_fecha === 0">
            <span class="selectgroup-button">Fecha única</span>
          </label>
          <label class="selectgroup-item">
            <input type="radio" name="fecha_form" [value]="1" id="fecha_form2" class="selectgroup-input"  (click)="fecha_dos()" [ngModel]="edit_tarea[0].tipo_fecha" [checked]="edit_tarea[0].tipo_fecha === 1">
            <span class="selectgroup-button">Fecha con Intervalo</span>
          </label>
         

        </div>
      </div>

     
      <div id="campo_fecha" style="display: block;">
        <label>Fecha</label>
        <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>

        <div class="form-group">
          <div class="input-group">
            <input class="form-control" placeholder="yyyy-mm-dd"
                   name="dp" [(ngModel)]="model"  ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar"  (click)="d.toggle()" type="button">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        
        

        <div class="form-group"  *ngIf="edit_tarea[0].tipo_fecha == 1">
          <label style="    width: 130px;">Fecha de termino</label> <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label><br>
          <div class="input-group">
            <input class="form-control" placeholder="yyyy-mm-dd"
                   name="dp2" [(ngModel)]="model2"  ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar"  (click)="d2.toggle()" type="button">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        


        
        <div class="row" *ngIf="edit_tarea[0].tipo_fecha == 0"> 
          <div class="col-md-6">
            <label style="    width: 120px;">Hora de Inicio</label>
             <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
            <ngb-timepicker name="algo" [(ngModel)]="time" [meridian]="true"></ngb-timepicker>
            <hr>
            <!-- <pre>Selected time: {{time.hour}} {{time.minute}}</pre> -->
            </div>
            <div class="col-md-6">
              <label style="    width: 120px;">Hora de Termino</label>
               <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
              <ngb-timepicker name="algo2" [(ngModel)]="time2" [meridian]="true"></ngb-timepicker>
              <hr>
            <!-- <pre>Selected time: {{time.hour}} {{time.minute}}</pre> -->
          </div>
        </div>



      </div>
      <div id="campo_fecha_intervalo" style="display: none;">
        <label>Fechas</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
        <input type="text" id="demo-3_1" value="05/17/2020 - 05/17/2020" class="form-control form-control-sm">
        <input type="text" id="result-3" style="display: none;">

      </div>
      <div class="form-group">
        <label class="form-label">Comentario</label>
        <div class="form-group">
          <div class="col-sm-12 col-md-12">
            <!-- <textarea  cols="10" rows="5" class="form-control" [(ngModel)]="task.comentario">{{task.comentario}}</textarea> -->
            <ckeditor [data]="task.comentario" [(ngModel)]="task.comentario" name="comentario" type="inline"></ckeditor>

            <!-- <div [froalaEditor]='options'  [(froalaModel)]="task.comentario">
              
            </div> -->
          </div>
        </div>
      </div>

     
      <div class="form-group">
        <label class=" mt-2">
          <input type="checkbox" id="privada" name="custom-switch-checkbox" class="custom-switch-input color"  [(ngModel)]="task.privado">
          <span class="custom-switch-indicator color" style=""></span>
          <span class="custom-switch-description ">¿Es una Tarea Privada?</span>
        </label>
      </div>

     <div class="form-group" id="color_notas">
        <label class="form-label">Color</label>
        <div class="col-8" id="">
            <input  type="color" id="color" [(value)]="task.color" [(ngModel)]="task.color"  name="color" class="form-control" />
        </div>
      </div>

    <h4 id="msng_error" style="font-size: 13px;"></h4>
    </div>
    <div class="modal-footer">
      <button type="submit" id="guardar_tarea" class="btn btn-primary" [disabled]="!addForm.form.valid || loading">
        <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loading, ' fa-refresh fa-spin':loading }"></i>
        Guardar</button>
    </div>
  </form>
  </div>



  <div class="card">
    <div class="header" style="height: 40px;">
      <h5 class="title color" id="exampleabel" style="color:#a5a8ad; float:left;">Editar Usuarios</h5>
      <button type="button" class="btn btn-danger btn-round"  style="float: right;" (click)="cerrar()">Cerrar Edición</button>
    </div>
    <form method="POST" #addForm="ngForm" (ngSubmit)="onSubmitUsers(addForm)">
      <div class="body">
      
    <div class="form-group">
      <label class="form-label">Usuarios</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
      <select class="selectpicker form-control" multiple  [(ngModel)]="task.usuarios" name="users" data-style="btn-info" data-size="6" data-show-subtext="true" data-live-search="true" title="Seleccia a los usuarios" required>
        <option *ngFor="let iuser of info?.new" value="{{iuser.id_usuario}}" >{{iuser.name}} {{iuser.last_name}}</option>
      </select>
    </div>
    
    <table class="table">
        <thead class="thead-dark">
            <tr>
              <th>Nombre archivo</th>  
              <th>Eliminar</th>
            </tr>
        </thead>
        <tbody>
          <tr *ngFor="let inf of info?.activo">
              <td>
                    <p style="width: 200px;">{{inf.name}} {{inf.last_name}}</p>
                </td>                  
                <td>
                  <a (click)="del_user_proyect(inf.tarea, inf.id_usuario)" style="cursor: pointer;"><i class="fa fa-times text-danger" aria-hidden="true"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
    
    </div>
    <div class="modal-footer">
      <button type="submit" id="guardar_tarea" class="btn btn-primary" [disabled]="!addForm.form.valid || loadingusers">
        <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loadingusers, ' fa-refresh fa-spin':loadingusers }"></i>
        Guardar</button>
    </div>
  </form>
</div>

</div>

  <div class="card">
    <div class="header" style="height: 40px;">
      <h5 class="title color" id="exampleabel" style="color:#a5a8ad; float:left;">Subir Documentos</h5>
      <button type="button" class="btn btn-danger btn-round"  style="float: right;" (click)="cerrar()">Cerrar Edición</button>
    </div>
    <form method="POST" #addForm="ngForm" (ngSubmit)="onSubmitDoc(addForm)">
      <div class="body">
        <div class="form-group">
          <label class="form-label">Subir archivos:</label>
          <div class="custom-file">
            <input type="file" style="cursor: pointer;" class="custom-file-input" id="inputGroupFile01"  name="imagen"  (change)="fileEvent($event)" multiple>
            <label class="custom-file-label" for="inputGroupFile01">Selecciona los archivos</label>
          </div>
        </div>
        <a (click)="limpiararchivos()"  *ngIf="archivos.length != 0" style="float: right; cursor: pointer;"><i class="fa fa-trash text-danger" aria-hidden="true"></i> Limpiar lista de archivos</a>
        <div class="table-responsive">
        <table class="table" *ngIf="archivos.length != 0">
          <thead class="thead-dark">
              <tr>
                  <th>Nombre archivo</th>
                  <th>Tamaño</th>
                  <th>Progreso</th>
                  <th>Eliminar</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let archivo of archivos; let i = index">
                  <td [ngClass]="{ 'text-green': archivo.progreso >= 100 }" >
                      <p style="width: 200px;">{{ archivo.nombreArchivo }}</p>
                  </td>
                  <td>
                      {{ archivo.archivo.size / 1024 /1024 | number: '.2-2' }} MB
                  </td>
                  <td>
                      <div class="progress">
                          <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': archivo.progreso + '%' }"></div>
                      </div>
                  </td>
                  <td>
                    <a (click)="eliminararchivo(i)" style="cursor: pointer;"><i class="fa fa-times text-danger" aria-hidden="true"></i></a>
                  </td>
              </tr>
          </tbody>
      </table>
      {{ mensaje }}
      <a (click)="limpiararchivos()"  *ngIf="archivos.length != 0" style="float: right; cursor: pointer;"><i class="fa fa-trash text-danger" aria-hidden="true"></i> Limpiar lista de archivos</a>

    </div>
    <h4 id="msng_error" style="font-size: 13px;"></h4>
    </div>
    <div class="modal-footer">
      <button type="submit" id="guardar_tarea" class="btn btn-primary" [disabled]="!addForm.form.valid || loadingdoc">
        <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loadingdoc, ' fa-refresh fa-spin':loadingdoc }"></i>
        Guardar</button>
    </div>
  </form>
  </div>


  <div class="card" *ngIf="info?.doc.length != 0">
    <div class="header" style="height: 40px;">
      <h5 class="title color" id="exampleabel" style="color:#a5a8ad; float:left;">Administrar Documentos</h5>
    </div>
      <div class="body">
        <div class="table-responsive">
        <table class="table">
          <thead class="thead-dark">
              <tr>
                <th>Nombre archivo</th>  
                <th>Eliminar</th>
              </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inf of info?.doc">
                <td>
                      <p style="width: 200px;">{{ inf.doc }}</p>
                  </td>                  
                  <td>
                    <a (click)="del_doc(inf.id_doc)" style="cursor: pointer;"><i class="fa fa-times text-danger" aria-hidden="true"></i></a>
                  </td>
              </tr>
          </tbody>
      </table>
    </div>
    </div>
  </div>
